import * as React from 'react'

type SidebarPropertyIconProps = React.SVGProps<SVGSVGElement> & {
  active?: boolean
  size?: number | string
}

export const SidebarPropertyIcon = React.forwardRef<SVGSVGElement, SidebarPropertyIconProps>(
  ({ active = false, size = 24, className, ...props }, ref) => {
    const primaryInactive = '#0B2B45'
    const primaryActive = '#FFFFFF'
    const accent = '#62C8DB'

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g transform="translate(8, 4) scale(0.95)">
          <path
            d="M24.47 10.22V0.76001H1.34998V29L8.68998 5.33001L24.47 10.22Z"
            fill={active ? primaryInactive : primaryActive}
          />
          <path
            d="M26.1 12.67L10.32 7.78L2.97998 31.45L0.97998 37.91L18.99 43.49C18.99 43.49 19.03 43.5 19.05 43.51L19.13 43.54C19.49 43.64 19.87 43.7 20.27 43.7C22.14 43.7 23.73 42.48 24.29 40.8L24.34 40.65L32.41 14.63L26.11 12.68L26.1 12.67Z"
            fill={accent}
          />
        </g>
      </svg>
    )
  },
)

SidebarPropertyIcon.displayName = 'SidebarPropertyIcon'
